import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("askt_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("askt_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("askt_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("askt_token"); localStorage.removeItem("askt_user"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("askt_token", data.token);
    localStorage.setItem("askt_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const previewLogin = async (role) => {
    const { data } = await api.post("/auth/preview", { role });
    localStorage.setItem("askt_token", data.token);
    localStorage.setItem("askt_user", JSON.stringify(data.user));
    localStorage.setItem("askt_preview", "1");
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    localStorage.setItem("askt_token", data.token);
    localStorage.setItem("askt_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("askt_token");
    localStorage.removeItem("askt_user");
    localStorage.removeItem("askt_preview");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, previewLogin, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
